import React from 'react';
import { getCardDisplay } from '../../utils/cardUtils';

function CardFace({ card }) {
  const { rank, suit, color } = getCardDisplay(card);

  return (
    <div className={`card-face card-face--${color}`}>
      <span className="card-face__corner card-face__corner--top">{rank}{suit}</span>
      <span className="card-face__center-rank">{rank}</span>
      <span className="card-face__center-suit">{suit}</span>
      <span className="card-face__corner card-face__corner--bottom">{rank}{suit}</span>
    </div>
  );
}

export default CardFace;
